import React, { useEffect } from 'react'
import BackButton from '../../components/BackButton'
import LanguageStrings from '../../i18n/locales'
import { useNavigate } from 'react-router-dom'
import './AssetGroup.css'
import GroupsTableComponent from './components/GroupsTableComponent'
import { connect, useSelector, type ConnectedProps } from 'react-redux'
import { type RootState } from '../../store'
import { Button } from '../../components/Button'
import { type OperationPermissionState } from '../dashboard/redux/operationPermissionSlice'
import { getOperationPermissions } from '../dashboard/redux/actionCreator'
import { useAuth } from 'react-oidc-context'
const AssetGroupStrings = LanguageStrings().AssetGroupStrings.AssetGroupMainComponentStrings

const AssetGroupMainComponent = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const auth = useAuth()
  const numGroups = useSelector((state: RootState) => state.assetGroupList.assetGroupsList !== null ? state.assetGroupList.assetGroupsList.total_count : 0)

  useEffect(() => {
    if (!props.operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
  }, [])

  // istanbul ignore next
  return (
    <div style={{ width: 'calc(100vw - 3.5rem)', paddingRight: '1rem' }}>
      <div className='link-breadcrumb'>
        <span data-testid='assetManagementbreadcrumb' onClick={ () => { navigate('/card') }} className='assetmgmtli'>{AssetGroupStrings.Asset_Management}</span>
        <span style={{ padding: '0 0.5em' }}>/</span>
        <span>{AssetGroupStrings.AssetGroup}</span>
      </div>
      <div className='topUtilityBar'>
        <BackButton onclick={() => { navigate('/card') }}/>
        <span id='componentTitle' data-testid='configurations'>{AssetGroupStrings.AssetGroup}</span>
        {
          props.operationPermissions.permissions.can_add_assetgroup &&
          <span id='top-right-ami-utilities'>
            <span id='top-right-btn-span'>
              <Button sx={{ margin: 0 }} onClick={() => { navigate('/create-asset-group') }} width='fit-content' dataTestId='create-group-btn'>{AssetGroupStrings.CreateAssetGroup}</Button>
            </span>
          </span>
        }
      </div>
      <div>
        <div className='configurations-table-heading'>
          <h5>{AssetGroupStrings.AssetGroupList} <span className='config-list-box'>{numGroups} {AssetGroupStrings.Groups}</span></h5>
        </div>
        <GroupsTableComponent />
      </div>
    </div>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub))
})

interface StateToProps {
  operationPermissions: OperationPermissionState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  operationPermissions: state.operationPermissions
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
export default connector(AssetGroupMainComponent)
